// extracted by mini-css-extract-plugin
module.exports = {"container":"price_container__V8SRt","price":"price_price__Ya74g","discounted":"price_discounted__c5bHF"};